export const FETCHED_BLOGS = 'fetchedBlogs'
export const FETCH_CITY_BLOGS = 'fetchCityBlogs'
export const FETCH_RECENT_BLOGS = 'fetchRecentBlogs'
